import Card from '~/components/Card';
import DescriptionList, {
  DescriptionListItem,
} from '~/components/DescriptionList';
import LinkButton from '~/components/LinkButton';
import Page from '~/components/Page';
import { formatDate } from '~/utils/formatters';
import { useLoaderData } from './registrationOverview';

export default function RegistrationOverviewPage() {
  const {
    isStartWarrantyClaimEnabled,
    registration,
    storeUrl,
    isEmbedded,
    registrationSubmissionText,
  } = useLoaderData();

  const {
    externalId,
    createdOn,
    email,
    orderIdFromPlatform: idFromPlatform,
  } = registration;

  const showActions = isStartWarrantyClaimEnabled || storeUrl;

  return (
    <Page headline="Registration Created">
      <Card>
        <p>
          <span className="font-sm text-gray-800">
            {registrationSubmissionText}
          </span>
        </p>
        <DescriptionList divide>
          <DescriptionListItem label="Confirmation" value={`#${externalId}`} />
          <DescriptionListItem label="Email" value={email} />
          <DescriptionListItem label="Created" value={formatDate(createdOn)} />
        </DescriptionList>

        {showActions && (
          <div className="gap mt-2 flex justify-between gap-6 *:flex-1 *:whitespace-nowrap">
            {storeUrl && !isEmbedded && (
              <LinkButton to={storeUrl} variant="outlined">
                Back To Merchant
              </LinkButton>
            )}

            {/* can we skip the hub and go straight to warranty here? */}
            {isStartWarrantyClaimEnabled && (
              <LinkButton
                variant="filled"
                // todo: this should go to the new request page, but the order page has the logic
                to={`../../order/${idFromPlatform}`}
              >
                Start A Claim
              </LinkButton>
            )}
          </div>
        )}
      </Card>
    </Page>
  );
}
